module.exports = __webpack_public_path__ + "img/12 Herb u. Winter neu.jpg";